import { SECONDARY_SOURCE_OPTIONS } from '#src/constants/secondary-sources.ts';
import type { SecondarySourceOption } from '#src/types/secondary-sources.ts';
import type { InstanceRecord } from '@astlai/common/types/instance';

/**
 * Sources the user can toggle for this instance. Web search is excluded when
 * alwaysOn since the server forces it regardless of the user setting.
 */
export function getAvailableSecondarySources(
	instance: InstanceRecord | undefined
): SecondarySourceOption[] {
	const flags = instance?.feature_flags?.secondarySources;
	if (!flags) {
		return [];
	}
	return SECONDARY_SOURCE_OPTIONS.filter((option) => {
		if (!flags[option.flagKey]?.enabled) {
			return false;
		}
		return !(option.flagKey === 'webSearch' && flags.webSearch?.settings?.alwaysOn);
	});
}
